export const LIST_PATHNAME_EDIT_CODE = ['/app/themes/edit']

export const DEFAULT_PAGE_NUMBER = 1
export const DEFAULT_PAGE_SIZE = 10
export const CDN_DOMAIN = 'https://product-labels.fercdn.net'
export const NAVIGATION = [
  {
    label: 'Orders',
    destination: '/app/orders',
  },
  {
    label: 'Quotes',
    destination: '/app/quotes',
  },
  {
    label: 'Reports',
    destination: '/app/reports',
  },
  {
    label: 'Customization',
    destination: '/app/template_customization',
  },
  {
    label: 'Automation Emails',
    destination: '/app/automations',
  },
  {
    label: 'Settings',
    destination: '/app/settings',
  },
  {
    label: 'Pricing',
    destination: '/app/pricing-plans',
  },
]
